import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

/**
 * 路由配置
 * - 使用 HTML5 history 模式；基础路径由 `process.env.BASE_URL` 提供。
 * - 首页：完整的主页布局（Navbar → 轮播图 → 新品 → 类别 → 视频 → 底部）。
 * - 关于页：示例占位（按需保留或移除）。
 */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/eng',
    name: 'english',
    // 英文版入口：懒加载英文首页视图，保持与中文主页一致的布局与比例
    component: () => import(/* webpackChunkName: "english" */ '@/english/views/EnglishHomeView-eng.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/eng/contact',
    name: 'contact-eng',
    component: () => import('@/english/views/ContactView-eng.vue')
  },
  {
    path: '/wechatPay',
    name: 'wechatPay',
    // 微信支付页面
    component: () => import(/* webpackChunkName: "wechatpay" */ '../views/WechatPay.vue')
  }
  ,{
    path: '/socials',
    name: 'socials',
    // 自媒体页面：包含传媒号、直播、评测等
    component: () => import(/* webpackChunkName: "socials" */ '../views/SocialsView.vue')
  },
  {
    path: '/eng/socials',
    name: 'socials-eng',
    // English Socials Page
    component: () => import(/* webpackChunkName: "socials-eng" */ '@/english/views/SocialsView-eng.vue')
  }
  ,{
    path: '/n',
    name: 'n',
    component: () => import('../views/NView.vue')
  }
  ,{
    path: '/bulk',
    name: 'bulk',
    // 批量采购页面
    component: () => import(/* webpackChunkName: "bulk" */ '../views/BulkPurchase.vue')
  },
  {
    path: '/eng/bulk',
    name: 'bulk-eng',
    component: () => import(/* webpackChunkName: "bulk-eng" */ '../english/views/BulkPurchase-eng.vue')
  },
  {
    path: '/e',
    name: 'erp',
    // ERP 跳转：访问 /e 直接跳转至外部 ERP 系统
    // component: HomeView, 
    component: { render: () => null },
    beforeEnter() {
      window.location.href = 'http://fjzmmd.mozilake.cn:6088/sysn/view/init/home.ashx'
    }
  },
  {
    path: '/t',
    name: 'kdocs',
    // 文档跳转：访问 /t 直接跳转至金山文档
    component: { render: () => null },
    beforeEnter() {
      window.location.href = 'https://kdocs.cn/join/g2kvtpz'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
